export * as DynamicConfig from './dynamic-config'
